import React, { useEffect, useState } from "react";
import { Card, Col, message, Row, Select } from 'antd';
import { Button } from "antd";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { GrTechnology } from "react-icons/gr";
import { FaXRay, FaRegKeyboard } from "react-icons/fa";
import { AiOutlineLogout } from "react-icons/ai";
import { HiUserGroup } from "react-icons/hi";

import './UserRoleSelection.css';
import { updateSessionRole, userSignOut } from "../appRedux/actions";

const { Option } = Select;

// const rolesObj = {
//     ROLE_ADMIN: "ROLE_ADMIN",
//     ROLE_MRT: "ROLE_MRT",
//     ROLE_MIS: "ROLE_MIS",
//     ROLE_TYP: "ROLE_TYP",
//     ROLE_GROUPADMIN: "ROLE_GROUPADMIN",
//     ROLE_GUILDLIBRARIAN: "ROLE_GUILDLIBRARIAN"
// };

const roleOptions = [
  { key: 'ROLE_ADMIN', label: 'RADISCAN ADMIN'  },
  { key: 'ROLE_GUILDLIBRARIAN', label: 'GUILD LIBRARIAN' },
  { key: 'ROLE_MRT', label: 'TECHNICIAN' },
  { key: 'ROLE_MIS', label: 'RADIOLOGIST' },
  { key: 'ROLE_TYP', label: 'TYP' },
  { key: 'ROLE_GROUPADMIN', label: 'PRACTICE ADMIN'  },
];

const UserRoleSelection = ({ authUser, updateSessionRole, userSignOut }) => {
    const { roles } = authUser;
    const [selectedRole, setSelectedRole] = useState(null);

    const handleProceed = (role) => {
        updateSessionRole(authUser.userId, role);
    }   

    const availableRoles = roleOptions.filter(role => roles.includes(role.key));

    const onSelectChange = (value) => {
        setSelectedRole(value);
    };

    const onContinueClick = () => {
        if (selectedRole) {
        handleProceed(selectedRole);
        }
    };

    return (
        <React.Fragment>
            <div className="gx-app-login-wrap" style={{ textAlign: 'center', }}>
                <div className="gx-app-logo">
                    <img alt="example" src={require("assets/images/clarity-logo.png")} />
                </div>
                <div className="gx-app-login-container">
                    <div style={{ textAlign: 'center' }}>
                        <h1 style={{ fontSize: '24px', fontWeight: '500' }}>
                            {`Hi, ${authUser ? authUser.firstName + ' ' + authUser.lastName : ''}!`}
                        </h1>
                        <h4 style={{ fontSize: '16px' }}>
                            Choose a role to proceed
                        </h4>
                    </div>
                    {/* <Row style={{ justifyContent: "center" }}>
                        {
                            roles.includes(rolesObj.ROLE_ADMIN) &&
                            <Col span={8}>
                                <Card className="cardH"
                                    bordered={false}
                                    style={{
                                        // backgroundColor: role === rolesObj.ROLE_ADMIN ? "#4EB0E8" : "white",
                                        // border: '1px solid lightgrey',
                                        // borderRadius: '12px',
                                        // boxShadow: '6px 9px 17px lightslategrey'
                                    }}
                                    onClick={() => handleProceed(rolesObj.ROLE_ADMIN)}
                                >
                                    <div style={{ textAlign: 'center' }}>
                                        <p><HiUserGroup style={{ fontSize: '76px' }} /></p>
                                        <p>RADISCAN ADMIN</p>
                                    </div>
                                </Card>
                            </Col>
                        }
                        {
                            roles.includes(rolesObj.ROLE_GUILDLIBRARIAN) &&
                            <Col span={8}>
                                <Card className="cardH"
                                    bordered={false}
                                    onClick={() => handleProceed(rolesObj.ROLE_GUILDLIBRARIAN)} 
                                >
                                    <div style={{ textAlign: 'center' }}>
                                        <p><HiUserGroup style={{ fontSize: '76px' }} /></p>
                                        <p>GUILD LIBRARIAN</p>
                                    </div>
                                </Card>
                            </Col>
                        }
                        {
                            roles.includes(rolesObj.ROLE_MRT) &&
                            <Col span={8}>
                                <Card className="cardH"
                                    bordered={false}
                                    style={{
                                        // backgroundColor: role === rolesObj.ROLE_MRT ? "#4EB0E8" : "white",
                                        // border: '1px solid lightgrey',
                                        // borderRadius: '12px',
                                        // boxShadow: '6px 9px 17px lightslategrey'
                                    }}
                                    onClick={() => handleProceed(rolesObj.ROLE_MRT)}
                                >
                                    <div style={{ textAlign: 'center' }}>
                                        <p><GrTechnology style={{ fontSize: '76px' }} /></p>
                                        <p>TECHNICIAN</p>
                                    </div>
                                </Card>
                            </Col>
                        }
                        {
                            roles.includes(rolesObj.ROLE_MIS) &&
                            <Col span={8}>
                                <Card className="cardH"
                                    bordered={false}
                                    style={{
                                        // backgroundColor: role === rolesObj.ROLE_MIS ? "#4EB0E8" : "white",
                                        // border: '1px solid lightgrey',
                                        // borderRadius: '12px',
                                        // boxShadow: '6px 9px 17px lightslategrey'
                                    }}
                                    onClick={() => handleProceed(rolesObj.ROLE_MIS)}
                                >
                                    <div style={{ textAlign: 'center' }}>
                                        <p><FaXRay style={{ fontSize: '76px' }} /></p>
                                        <p>RADIOLOGIST</p>
                                    </div>
                                </Card>
                            </Col>
                        }
                        {
                            roles.includes(rolesObj.ROLE_TYP) &&
                            <Col span={8}>
                                <Card className="cardH"
                                    bordered={false}
                                    style={{
                                        // backgroundColor: role === rolesObj.ROLE_TYP ? "#4EB0E8" : "white",
                                        // border: '1px solid lightgrey',
                                        // borderRadius: '12px',
                                        // boxShadow: '6px 9px 17px lightslategrey'
                                    }}
                                    onClick={() => handleProceed(rolesObj.ROLE_TYP)}
                                >
                                    <div style={{ textAlign: 'center' }}>
                                        <p><FaRegKeyboard style={{ fontSize: '76px' }} /></p>
                                        <p>TYP</p>
                                    </div>
                                </Card>
                            </Col>
                        }
                        {
                            roles.includes(rolesObj.ROLE_GROUPADMIN) &&
                            <Col span={8}>
                                <Card className="cardH"
                                    bordered={false}
                                    style={{
                                        // backgroundColor: role === rolesObj.ROLE_GROUPADMIN ? "#4EB0E8" : "white",
                                        // border: '1px solid lightgrey',
                                        // borderRadius: '12px',
                                        // boxShadow: '6px 9px 17px lightslategrey'
                                    }}
                                    onClick={() => handleProceed(rolesObj.ROLE_GROUPADMIN)}
                                >
                                    <div style={{ textAlign: 'center' }}>
                                        <p><HiUserGroup style={{ fontSize: '76px' }} /></p>
                                        <p>PRACTICE ADMIN</p>
                                    </div>
                                </Card>
                            </Col>
                        }
                    </Row> */}
                    <Row style={{ marginTop: 10, justifyContent:'center', width: '360px', gap: '35px' }}>
                        <Select
                        style={{ width: '100%' }}
                        placeholder="Select a role"
                        onChange={onSelectChange}
                        dropdownClassName="select-common-dropdown"
                        >
                        {availableRoles.map(role => (
                            <Option key={role.key} value={role.key}>
                            <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                {role.label}
                            </span>
                            </Option>
                        ))}
                        </Select>
                        <Button
                            type="primary"
                            block
                            disabled={!selectedRole}
                            onClick={onContinueClick}
                            style={{ minHeight: '45px' }}
                        >
                            Continue
                        </Button>
                    </Row>
                    <br />
                </div>
            </div>
            <div style={{ position: "absolute", top: '1rem', right: '2rem' }}>
                <Button type="default" size='large' onClick={userSignOut} shape="circle" style={{ alignItems: "center", justifyContent: "center", display: "flex" }}>
                    <AiOutlineLogout size="1.3em" />
                </Button>
            </div>
        </React.Fragment>
    );
}

export const mapDispatchToProps = dispatch => ({
    userSignOut: bindActionCreators(userSignOut, dispatch),
    updateSessionRole: bindActionCreators(updateSessionRole, dispatch)
});

const mapStateToProps = ({ auth }) => {
    return {
        authUser: auth ? auth.authUser : null,
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(UserRoleSelection);

